﻿export const AppContainerId = 'veilederborteboerstipend';
export const BoksA = 'boks-a';
export const BoksB = 'boks-b';
export const BoksResultat = 'resultat';
